import useAPI from '../useAPI'
import { create } from '@/api/favicon.api'

export const useCreateFavicon = (params = {}) => useAPI({
  request: create,
  params
})
